"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryAllLiquidationResponse = exports.QueryAllLiquidationRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const liquidation_1 = require("../liquidation/liquidation");
const trade_1 = require("../misc/trade");
exports.protobufPackage = "Switcheo.carbon.liquidation";
const baseQueryAllLiquidationRequest = {
    address: "",
    market: "",
    limit: long_1.default.UZERO,
    beforeId: long_1.default.UZERO,
    afterId: long_1.default.UZERO,
    orderBy: "",
    orderId: "",
    afterBlock: long_1.default.UZERO,
    beforeBlock: long_1.default.UZERO,
};
exports.QueryAllLiquidationRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.market !== "") {
            writer.uint32(18).string(message.market);
        }
        if (!message.limit.isZero()) {
            writer.uint32(24).uint64(message.limit);
        }
        if (!message.beforeId.isZero()) {
            writer.uint32(32).uint64(message.beforeId);
        }
        if (!message.afterId.isZero()) {
            writer.uint32(40).uint64(message.afterId);
        }
        if (message.orderBy !== "") {
            writer.uint32(50).string(message.orderBy);
        }
        if (message.orderId !== "") {
            writer.uint32(58).string(message.orderId);
        }
        if (!message.afterBlock.isZero()) {
            writer.uint32(64).uint64(message.afterBlock);
        }
        if (!message.beforeBlock.isZero()) {
            writer.uint32(72).uint64(message.beforeBlock);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllLiquidationRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.market = reader.string();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.beforeId = reader.uint64();
                    break;
                case 5:
                    message.afterId = reader.uint64();
                    break;
                case 6:
                    message.orderBy = reader.string();
                    break;
                case 7:
                    message.orderId = reader.string();
                    break;
                case 8:
                    message.afterBlock = reader.uint64();
                    break;
                case 9:
                    message.beforeBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllLiquidationRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.market =
            object.market !== undefined && object.market !== null
                ? String(object.market)
                : "";
        message.limit =
            object.limit !== undefined && object.limit !== null
                ? long_1.default.fromString(object.limit)
                : long_1.default.UZERO;
        message.beforeId =
            object.beforeId !== undefined && object.beforeId !== null
                ? long_1.default.fromString(object.beforeId)
                : long_1.default.UZERO;
        message.afterId =
            object.afterId !== undefined && object.afterId !== null
                ? long_1.default.fromString(object.afterId)
                : long_1.default.UZERO;
        message.orderBy =
            object.orderBy !== undefined && object.orderBy !== null
                ? String(object.orderBy)
                : "";
        message.orderId =
            object.orderId !== undefined && object.orderId !== null
                ? String(object.orderId)
                : "";
        message.afterBlock =
            object.afterBlock !== undefined && object.afterBlock !== null
                ? long_1.default.fromString(object.afterBlock)
                : long_1.default.UZERO;
        message.beforeBlock =
            object.beforeBlock !== undefined && object.beforeBlock !== null
                ? long_1.default.fromString(object.beforeBlock)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.market !== undefined && (obj.market = message.market);
        message.limit !== undefined &&
            (obj.limit = (message.limit || long_1.default.UZERO).toString());
        message.beforeId !== undefined &&
            (obj.beforeId = (message.beforeId || long_1.default.UZERO).toString());
        message.afterId !== undefined &&
            (obj.afterId = (message.afterId || long_1.default.UZERO).toString());
        message.orderBy !== undefined && (obj.orderBy = message.orderBy);
        message.orderId !== undefined && (obj.orderId = message.orderId);
        message.afterBlock !== undefined &&
            (obj.afterBlock = (message.afterBlock || long_1.default.UZERO).toString());
        message.beforeBlock !== undefined &&
            (obj.beforeBlock = (message.beforeBlock || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseQueryAllLiquidationRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.market = (_b = object.market) !== null && _b !== void 0 ? _b : "";
        message.limit =
            object.limit !== undefined && object.limit !== null
                ? long_1.default.fromValue(object.limit)
                : long_1.default.UZERO;
        message.beforeId =
            object.beforeId !== undefined && object.beforeId !== null
                ? long_1.default.fromValue(object.beforeId)
                : long_1.default.UZERO;
        message.afterId =
            object.afterId !== undefined && object.afterId !== null
                ? long_1.default.fromValue(object.afterId)
                : long_1.default.UZERO;
        message.orderBy = (_c = object.orderBy) !== null && _c !== void 0 ? _c : "";
        message.orderId = (_d = object.orderId) !== null && _d !== void 0 ? _d : "";
        message.afterBlock =
            object.afterBlock !== undefined && object.afterBlock !== null
                ? long_1.default.fromValue(object.afterBlock)
                : long_1.default.UZERO;
        message.beforeBlock =
            object.beforeBlock !== undefined && object.beforeBlock !== null
                ? long_1.default.fromValue(object.beforeBlock)
                : long_1.default.UZERO;
        return message;
    },
};
const baseQueryAllLiquidationResponse = {};
exports.QueryAllLiquidationResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.trades) {
            trade_1.AccountTrade.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllLiquidationResponse);
        message.trades = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.trades.push(trade_1.AccountTrade.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllLiquidationResponse);
        message.trades = ((_a = object.trades) !== null && _a !== void 0 ? _a : []).map((e) => trade_1.AccountTrade.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.trades) {
            obj.trades = message.trades.map((e) => e ? trade_1.AccountTrade.toJSON(e) : undefined);
        }
        else {
            obj.trades = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllLiquidationResponse);
        message.trades = ((_a = object.trades) !== null && _a !== void 0 ? _a : []).map((e) => trade_1.AccountTrade.fromPartial(e));
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            liquidation_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = liquidation_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? liquidation_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? liquidation_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? liquidation_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.LiquidationAll = this.LiquidationAll.bind(this);
        this.Params = this.Params.bind(this);
    }
    LiquidationAll(request) {
        const data = exports.QueryAllLiquidationRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquidation.Query", "LiquidationAll", data);
        return promise.then((data) => exports.QueryAllLiquidationResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquidation.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
